/*
* @Author: gujianghua
* @Date:   2019-09-25 11:08:09
* @Last Modified by:   gujianghua
* @Last Modified time: 2019-09-25 11:09:40
*/
import { service } from '@/utils/request'

export default {
	//生成短连接
	getShorturl(data) {
	  return service({
	    url: '/cloud/bbs/v1/app/config/shortURL',
	    method: 'post',
	    data: data
	  })
	}
}


// WEBPACK FOOTER //
// ./src/api/operateManage/shorturl.js